export enum StoreModule {
  User = "user/",
  Global = "global/",
  Customer = "customer/",
  Rep = "rep/",
  Export = "exportFeature/"
}
